import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

export default function Plantilla() {
  const [maquinistas, setMaquinistas] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/maquinistas/').then(r => setMaquinistas(r.data)).finally(() => setLoading(false));
  }, []);

  const diasHasta = (fecha) => {
    if (!fecha) return null;
    const dias = Math.ceil((new Date(fecha) - new Date()) / 86400000);
    return dias;
  };

  const estadoMedico = (fecha) => {
    const dias = diasHasta(fecha);
    if (dias === null) return { color: '#888', bg: '#f0f0f0', label: 'Sin datos' };
    if (dias < 0) return { color: '#a32d2d', bg: '#fcebeb', label: 'Caducado' };
    if (dias < 30) return { color: '#a32d2d', bg: '#fcebeb', label: `Caduca en ${dias}d` };
    if (dias < 90) return { color: '#854f0b', bg: '#faeeda', label: `Caduca en ${dias}d` };
    return { color: '#3b6d11', bg: '#eaf3de', label: `Válido ${dias}d` };
  };

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Plantilla</h2>
        <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>{maquinistas.length} maquinistas activos</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 12 }}>
        {maquinistas.map(m => {
          const medico = estadoMedico(m.proximo_medico);
          return (
            <div key={m.id} onClick={() => navigate(`/staff/maquinista/${m.id}`)}
              style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 18, cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{m.nombre} {m.apellidos}</div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{m.dni}</div>
                </div>
                <span style={{ background: medico.bg, color: medico.color, borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 500 }}>
                  {medico.label}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 16, fontSize: 12, color: '#555' }}>
                <span>🚂 {m.habs_material} modelos</span>
                <span>🛤️ {m.habs_linea} líneas</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
